import styled from 'styled-components';
import Typography from '../Typography/Typography';

// noinspection CssInvalidPropertyValue
export const StyledTypography = styled(Typography)`
    color: inherit;
    vertical-align: middle;
    text-wrap: nowrap;
    cursor: default;
`;

export const UppercaseLabelText = (props) => <StyledTypography {...props} variant='uiType' size='3xs' modifier='SU' />;
export const LabelText = (props) => <StyledTypography {...props} variant='uiType' size='2xs' modifier='R' />;
